import { styled } from '@lichtblick/styled';

export const ScrollShadowViewport = styled.div`
  --layout-scroll-shadow-size: var(--spacing-xl);
  --layout-scroll-shadow-corner-opacity-factor: 0.75;
  --layout-scroll-shadow-multi-axis-factor: 0;
  --layout-scroll-shadow-scrollbar-inline-size: 0px;
  --layout-scroll-shadow-scrollbar-block-size: 0px;
  --layout-scroll-shadow-top-opacity: 0;
  --layout-scroll-shadow-right-opacity: 0;
  --layout-scroll-shadow-bottom-opacity: 0;
  --layout-scroll-shadow-left-opacity: 0;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  position: relative;
  width: 100%;

  &::before,
  &::after {
    content: '';
    inset: 0 var(--layout-scroll-shadow-scrollbar-inline-size) var(--layout-scroll-shadow-scrollbar-block-size) 0;
    pointer-events: none;
    position: absolute;
    z-index: var(--z-index-sticky);
  }

  &::before {
    background-image:
      linear-gradient(to bottom, rgba(0, 0, 0, var(--layout-scroll-shadow-top-opacity)), rgba(0, 0, 0, 0)),
      linear-gradient(to top, rgba(0, 0, 0, var(--layout-scroll-shadow-bottom-opacity)), rgba(0, 0, 0, 0)),
      linear-gradient(to right, rgba(0, 0, 0, var(--layout-scroll-shadow-left-opacity)), rgba(0, 0, 0, 0)),
      linear-gradient(to left, rgba(0, 0, 0, var(--layout-scroll-shadow-right-opacity)), rgba(0, 0, 0, 0));
    background-position:
      top center,
      bottom center,
      center left,
      center right;
    background-repeat: no-repeat;
    background-size:
      100% var(--layout-scroll-shadow-size),
      100% var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) 100%,
      var(--layout-scroll-shadow-size) 100%;
  }

  &::after {
    --layout-scroll-shadow-corner-top-left-opacity: calc(
      max(var(--layout-scroll-shadow-top-opacity), var(--layout-scroll-shadow-left-opacity)) *
        var(--layout-scroll-shadow-corner-opacity-factor) * var(--layout-scroll-shadow-multi-axis-factor)
    );
    --layout-scroll-shadow-corner-top-right-opacity: calc(
      max(var(--layout-scroll-shadow-top-opacity), var(--layout-scroll-shadow-right-opacity)) *
        var(--layout-scroll-shadow-corner-opacity-factor) * var(--layout-scroll-shadow-multi-axis-factor)
    );
    --layout-scroll-shadow-corner-bottom-left-opacity: calc(
      max(var(--layout-scroll-shadow-bottom-opacity), var(--layout-scroll-shadow-left-opacity)) *
        var(--layout-scroll-shadow-corner-opacity-factor) * var(--layout-scroll-shadow-multi-axis-factor)
    );
    --layout-scroll-shadow-corner-bottom-right-opacity: calc(
      max(var(--layout-scroll-shadow-bottom-opacity), var(--layout-scroll-shadow-right-opacity)) *
        var(--layout-scroll-shadow-corner-opacity-factor) * var(--layout-scroll-shadow-multi-axis-factor)
    );

    background-image:
      linear-gradient(
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-top-left-opacity)),
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-top-left-opacity))
      ),
      linear-gradient(
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-top-right-opacity)),
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-top-right-opacity))
      ),
      linear-gradient(
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-bottom-left-opacity)),
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-bottom-left-opacity))
      ),
      linear-gradient(
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-bottom-right-opacity)),
        rgba(0, 0, 0, var(--layout-scroll-shadow-corner-bottom-right-opacity))
      );
    background-position:
      top left,
      top right,
      bottom left,
      bottom right;
    background-repeat: no-repeat;
    background-size:
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size);
    -webkit-mask-image:
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='0' cy='0' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='100' cy='0' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='0' cy='100' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='100' cy='100' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E");
    -webkit-mask-position:
      top left,
      top right,
      bottom left,
      bottom right;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size:
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size);
    mask-image:
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='0' cy='0' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='100' cy='0' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='0' cy='100' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cdefs%3E%3CradialGradient id='g' cx='100' cy='100' r='100' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='white'/%3E%3Cstop offset='1' stop-color='black' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23g)'/%3E%3C/svg%3E");
    mask-position:
      top left,
      top right,
      bottom left,
      bottom right;
    mask-repeat: no-repeat;
    mask-size:
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size),
      var(--layout-scroll-shadow-size) var(--layout-scroll-shadow-size);
  }
`;
